module.exports = __webpack_public_path__ + "static/media/cuadro-2-analisis.3bd90ca2.png";